import Button from "components/shared/Button";
import { Icon } from "@wdpr/groot-components";
import { Context } from "Context";
import { useContext } from "react";
import { getCdn } from "utils";

const handleBackButtonClick = (event) => {
	event?.preventDefault();
	document?.dispatchEvent(
		new CustomEvent("navigationBackButton", {
			detail: {
				clicked: true,
			},
		})
	);
};

const BackButton = ({ isMobileView }) => {
	const {
		headerData: { backButton },
	} = useContext(Context);

	if (!backButton) return null;

	return (
		<Button
			analyticsLinkId={backButton.link?.analyticsLinkId}
			onClick={handleBackButtonClick}
			className="syndicated-navigation__nav__back-button"
		>
			<Icon icon={backButton.icon} getCdn={getCdn} />
			{isMobileView ? "" : backButton.link?.title}
		</Button>
	);
};

export default BackButton;
